export default __webpack_public_path__ + "static/media/2005.93a97949.png";